import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    playerWrapper: {
        position: 'relative',
        paddingTop: '56.25%',
        width: '100%',
    },
    reactPlayer: {
        position: 'absolute',
        top: 0,
        left: 0,
        '& .react-player__preview': {
            backgroundSize: 'contain !important',
            backgroundRepeat: 'no-repeat',
        },
    },
}));
